import {StoreRoute} from "./enum";
import {flattenRouteInfo} from "../helpers/flattenRouteInfo";
import {getStoreUrl} from "./helpers/getStoreUrl";

/**
 * ROUTE
 * - id: StoreRoute
 * - path: string
 * - children: ROUTE[] [optional]
 *
 * Route Blocking due to Permission or Subscription
 * - permission: PermissionKey
 * - subscription: SubscriptionScopeKey
 * - create: boolean
 * - update: boolean
 * - view: boolean
 * - inhibitorModifiers: Array of M3
 *
 * Wrapper Provider
 * - wrapper: Provider
 * - wrapperProps: props-like object {}
 *
 * Miscellaneous
 * - sidebarParentId: StoreRoute
 */

const StoreRouteInfo = [
    {
        id: StoreRoute.Landing,
        path: '/',
    },
    {
        id: StoreRoute.Category,
        path: 'category/:id',
    },
    {
        id: StoreRoute.Search,
        path: 'search/:keyword',
    },
    {
        path: 'orders',
        children: [
            {
                id: StoreRoute.Orders,
                path: '/',
            },
            {
                id: StoreRoute.OrderError,
                path: 'error',
            },
            {
                path: ':key',
                children: [
                    {
                        id: StoreRoute.OrderView,
                        path: '/',
                    },
                    {
                        id: StoreRoute.OrderPay,
                        path: 'pay',
                    },
                ],
            },
        ],
    },
];

export default flattenRouteInfo(StoreRouteInfo).map(route => ({
    ...route,
    path: getStoreUrl(route.path, ':cs')}
));
